// extracted by mini-css-extract-plugin
export var authorComment = "style-mod--author-comment--f736d";
export var contentCol = "style-mod--content-col--60d64";
export var contentTd = "style-mod--content-td--464df";
export var description = "style-mod--description--cb334";
export var imageCol = "style-mod--image-col--848ff";
export var img = "style-mod--img--41413";
export var mainContainer = "style-mod--main-container--102d0";
export var personDesc = "style-mod--person-desc--25494";
export var personTitle = "style-mod--person-title--a76c0";
export var tiContent = "style-mod--ti-content--8f7af";
export var title = "style-mod--title--38f97";